import { render, staticRenderFns } from "./bonus.vue?vue&type=template&id=7a0ec8e0&scoped=true"
import script from "./bonus.vue?vue&type=script&lang=js"
export * from "./bonus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0ec8e0",
  null
  
)

export default component.exports